import type {TeamInvite, TeamInviteData, TeamInviteResp, TeamUser, UpdatePermissions} from "~/types/team-user-invite";
import type {SelectOption} from "~/types";

export const useTeamUserInvite = () => {
  const baseUrl = '/team-user-invite'
  const {fetch} = useAjax()

  const roleOptions = [
    {label: 'Dono (Acesso total)', value: 'OWNER'},
    {label: 'Gerente (Acesso total menos financeiro)', value: 'ADMIN'},
    {label: 'Portaria/Check-in (Apenas check-in)', value: 'CHECK_IN'},
  ]

  const statusOptions = [
    {label: 'Pendente', value: 'PENDING'},
    {label: 'Aceito', value: 'ACCEPTED'},
    {label: 'Expirado', value: 'EXPIRED'},
    {label: 'Recusado', value: 'REJECTED'},
  ]

  const getAllVinculatedProducers = async (): Promise<SelectOption[]> => {
    return await fetch<SelectOption[]>(`${baseUrl}/all-user-adms`)
  }

  const getAllTeamUser = async (): Promise<TeamUser[]> => {
    return await fetch<TeamUser[]>(`${baseUrl}/all-team-users`)
  }

  const getAllInvites = async (): Promise<TeamInviteData[]> => {
    return await fetch<TeamInviteData[]>(baseUrl)
  }

  const activeInactiveMember = async (id: string): Promise<void> => {
    await fetch<void>(`${baseUrl}/active-inactive/${id}`, {method: 'POST'})
  }

  const updatePermissions = async (body: UpdatePermissions): Promise<void> => {
    await fetch<void>(`${baseUrl}/permissions`, {
      method: 'POST',
      body
    })
  }

  const addInvitation = async (body: TeamInvite): Promise<boolean> => {
    try {
      await fetch<void>(`${baseUrl}/create`, {
        method: "POST",
        body
      })
      return true
    } catch (e: any) {
      return false
    }
  }

  const recuseInvitation = async (token: string): Promise<void> => {
    try {
      await fetch<void>(`${baseUrl}/pub/recuse?t=${token}`, {
        method: "POST"
      })
    } catch (e: any) {
    }
  }

  const acceptInvitation = async (token: string): Promise<void> => {
    await fetch<void>(`${baseUrl}/pub/accept?t=${token}`, {
      method: "POST"
    })
  }

  const deleteInvite = async (id: string): Promise<void> => {
    try {
      await fetch<void>(`${baseUrl}/${id}`, {
        method: "DELETE"
      })
    } catch (e: any) {
      Alert.error("Não foi possível remover o registro, atualize a página e tente novamente")
    }
  }

  const findInvitation = async (token: string): Promise<TeamInviteResp> => {
    try {
      return fetch<TeamInviteResp>(`${baseUrl}/pub?t=${token}`)
    } catch (e: any) {
      return {
        hasUser: false,
        email: '',
        error: e.message
      } as TeamInviteResp
    }
  }

  return {
    recuseInvitation, acceptInvitation, findInvitation, addInvitation,
    getAllVinculatedProducers, getAllInvites, deleteInvite, getAllTeamUser,
    activeInactiveMember, updatePermissions, statusOptions, roleOptions
  }

}
